import { render, staticRenderFns } from "./SortByFilters.vue?vue&type=template&id=a19d9f8a&scoped=true&"
import script from "./SortByFilters.vue?vue&type=script&lang=js&"
export * from "./SortByFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19d9f8a",
  null
  
)

export default component.exports